let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1O6cT")).then(() => parcelRequire('5xNz1'));